import { render, staticRenderFns } from "./UploadedImage.vue?vue&type=template&id=8c823ea2&scoped=true&"
import script from "./UploadedImage.vue?vue&type=script&lang=js&"
export * from "./UploadedImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadedImage.vue?vue&type=style&index=0&id=8c823ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c823ea2",
  null
  
)

export default component.exports